import SpeAiAssistedFlowMockPage from "@faire/prototype-playground/workspace/yz/spe-ai-assisted-flow-mock";
import SpeAiInlineSpeMockPage from "@faire/prototype-playground/workspace/yz/spe-ai-inline-spe-mock";
import Fin490BcRetailerProfilePage from "@faire/prototype-playground/workspace/yz/fin-490-bc-retailer-profile";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const CommissionInvoicePage = lazy(
  () => import("@faire/prototype-playground/workspace/yz/commission-invoice")
);
const OrderPayoutSummaryPage = lazy(
  () => import("@faire/prototype-playground/workspace/yz/order-payout-summary")
);

export function YikaiZhouRoutes() {
  return (
    <Switch>
      <Route path="/yz/commission-invoice" component={CommissionInvoicePage} />
      <Route
        path="/yz/fin-490-bc-retailer-profile"
        component={Fin490BcRetailerProfilePage}
      />
      <Route
        path="/yz/order-payout-summary"
        component={OrderPayoutSummaryPage}
      />
      <Route
        path="/yz/spe-ai-assisted-flow-mock"
        component={SpeAiAssistedFlowMockPage}
      />
      <Route
        path="/yz/spe-ai-inline-spe-mock"
        component={SpeAiInlineSpeMockPage}
      />
    </Switch>
  );
}

export const slug = "yz";
